// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
  InputAdornment,
  Grid,
  Alert,
  Zoom,
  Button,
  Tooltip,
  Box,
} from "@mui/material";
import {
  Remove as RemoveIcon,
  Add as AddIcon,
  UploadFile as UploadFileIcon,
} from "@mui/icons-material";
import AlertMessage from "../Alias/AlertMessage";
import SearchInput from "./Componentes/SearchInput";
import { EmailsModal } from "./Componentes/nueva-lista/EmailsModal";
import { parsearCSVEmails } from "./Componentes/nueva-lista/parsearCSVEmails";
import { ImportarCSVModal } from "./Componentes/nueva-lista/ImportarCSVModal";
import { EMAILS_PER_PAGE, SIZE_MD } from "../Contantes/Constantes";
import usePagination from "../Componentes/usePagination";
import Paginador from "../Alias/Componentes/Paginador";
import { TextFieldRojo } from "../App";

const MAX_CSV_BYTES = 5 * 1024 * 1024;

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function ItemListaEmails({
  handleEmailsChange,
  emails,
  isModificar,
  requiereBuscador = true,
}) {
  const [emailInput, setEmailInput] = useState("");
  const [resultado, setResultado] = useState(emails);
  const pasted = useRef(false);
  const inputCSV = useRef(null);
  const [alert, setAlert] = useState(null);
  const [openModalLista, setOpenModalLista] = useState(false);
  const [openModalCSV, setOpenModalCSV] = useState(false);
  const [fallados, setFallados] = useState([]);
  const [emailsAlPrincipio, setEmailsAlPrincipio] = useState([]);
  const [borrarEmailsAlPrincipio, setBorrarEmailsAlPrincipio] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const { pageCount, paginateAliases } = usePagination(
    resultado,
    isModificar ? EMAILS_PER_PAGE : 16
  );
  const emailsForDisplay = paginateAliases(resultado, currentPage);

  useEffect(() => setResultado(emails), [emails]);

  useEffect(() => {
    if (borrarEmailsAlPrincipio) {
      setEmailsAlPrincipio([]);
    } else {
      setBorrarEmailsAlPrincipio(true);
    }
  }, [currentPage]);

  const handleInputChange = (e) => {
    if (!pasted.current) setEmailInput(e.target.value);
    pasted.current = false;
  };

  const separarMails = (text) =>
    text
      .split(/[;,\n\s]+/)
      .map((e) => e.trim())
      .filter(Boolean);

  const validateEmail = (email) => EMAIL_REGEX.test(email.toLowerCase());

  const showError = (message, emailsInvalidos = []) => {
    setAlert({ status: "error", message });
    setFallados([]);
    if (emailsInvalidos.length > 0) setEmailInput(emailsInvalidos.join(", "));
  };

  const eliminarDuplicadosYCargar = (lista, quitarAlPrincipio = true) => {
    if (quitarAlPrincipio) setEmailsAlPrincipio([]);
    if (currentPage !== 1) setBorrarEmailsAlPrincipio(false);

    const únicos = [...new Set(lista)];
    const inválidos = [];
    const validos = [];

    únicos.forEach((email) => {
      if (validateEmail(email)) {
        if (!emails.includes(email)) {
          validos.push(email);
        } else {
          showError("El mail ya está en la lista");
        }
        setEmailsAlPrincipio((prev) => [...prev, email]);
      } else {
        inválidos.push(email);
      }
    });

    setResultado([...resultado, ...validos]);
    handleEmailsChange([...resultado, ...validos]);
    setEmailInput("");

    if (inválidos.length) {
      showError(
        "Ocurrió un error al querer añadir las casillas de correo, controle bien la estructura y que pertenezcan al dominio @frba.utn.edu.ar",
        inválidos
      );
    }

    setCurrentPage(1);
  };

  const borrarEmail = (email) => {
    const actualizados = emails.filter((e) => e !== email);
    handleEmailsChange(actualizados);
    setEmailsAlPrincipio((prev) => prev.filter((e) => e !== email));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      eliminarDuplicadosYCargar(separarMails(emailInput));
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    const pastedEmails = separarMails(e.clipboardData.getData("Text"));
    eliminarDuplicadosYCargar(pastedEmails);
    pasted.current = true;
  };

  const handleArchivoCSV = (e) => {
    const archivo = e.target.files?.[0];
    e.target.value = "";
    setOpenModalCSV(false);
    if (!archivo) return;

    if (archivo.size > MAX_CSV_BYTES) {
      setAlert({
        status: "error",
        message: "El archivo es demasiado grande (máximo 5 MB).",
      });
      return;
    }

    const lector = new FileReader();
    lector.onerror = () =>
      setAlert({ status: "error", message: "No se pudo leer el archivo." });
    lector.onload = () => {
      const encontrados = parsearCSVEmails(String(lector.result));
      if (encontrados.length === 0) {
        setAlert({
          status: "error",
          message: "No se encontraron correos en el archivo.",
        });
        return;
      }
      eliminarDuplicadosYCargar(encontrados);
    };
    lector.readAsText(archivo);
  };

  const emailItem = (email) => (
    <Grid item xs={window.innerWidth < SIZE_MD ? 12 : 6} key={email}>
        <ListItem
          secondaryAction={
            isModificar && (
              <IconButton onClick={() => borrarEmail(email)} size="large">
                <RemoveIcon />
              </IconButton>
            )
          }
        >
          <ListItemText
            primary={
              validateEmail(email) ? (
                <div
                  style={{
                    width: "80%",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {email}
                </div>
              ) : (
                <div style={{ color: "#cc0000" }}>{email}</div>
              )
            }
          />
        </ListItem>
    </Grid>
  );

  const buscarVolviendoAPrimerPagina = (value) => {
    if (currentPage !== 1) setCurrentPage(1);
    setResultado(value);
  };

  const diferenciaDeArreglos = (arr1, arr2) =>
    arr1.filter((e) => !arr2.includes(e));

  const emailsVisibles = [
    ...emailsAlPrincipio.sort().slice(0, EMAILS_PER_PAGE),
    ...diferenciaDeArreglos(emailsForDisplay, emailsAlPrincipio).slice(
      0,
      EMAILS_PER_PAGE - emailsAlPrincipio.length
    ),
  ];

  return (
    <div>
      <AlertMessage alert={alert} setAlert={setAlert} />

      {isModificar && (
        <TextFieldRojo
          multiline
          maxRows={1}
          label="Ingrese correos"
          fullWidth
          value={emailInput}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          onPaste={handlePaste}
          error={alert?.status === "error"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() =>
                    eliminarDuplicadosYCargar(separarMails(emailInput))
                  }
                  size="large"
                >
                  <AddIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}

      {isModificar && (
        <>
          <input
            ref={inputCSV}
            type="file"
            accept=".csv,text/csv"
            style={{ display: "none" }}
            onChange={handleArchivoCSV}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Tooltip title="Importar destinatarios desde un archivo CSV">
              <Button
                sx={{ textTransform: "none" }}
                size="small"
                variant="outlined"
                startIcon={<UploadFileIcon />}
                onClick={() => setOpenModalCSV(true)}
              >
                Importar CSV
              </Button>
            </Tooltip>
          </Box>

          <Alert severity="info" sx={{ mt: 2 }}>
            Puede insertar múltiples correos separados por coma (`,`), punto y
            coma (`;`) o presionando Enter.
            <br />
            Puede escribirlos, pegarlos directamente o importarlos desde un
            archivo CSV.
          </Alert>

          <ImportarCSVModal
            open={openModalCSV}
            onClose={() => setOpenModalCSV(false)}
            onSeleccionarArchivo={() => inputCSV.current?.click()}
          />
        </>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: 56,
        }}
      >
        <Typography variant="h6">Destinatarios</Typography>
        {requiereBuscador && (
          <SearchInput
            lista={emails}
            resultado={resultado}
            setResultado={buscarVolviendoAPrimerPagina}
          />
        )}
      </div>

      <List>
        <Grid container>{emailsVisibles.map(emailItem)}</Grid>
      </List>

      {resultado.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
          No hay destinatarios.
        </Typography>
      )}

      <Paginador
        aliasesCount={resultado.length}
        pageCount={pageCount}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <EmailsModal
        emails={emails}
        setEmails={(nuevos) =>
          handleEmailsChange((prev) => [...prev, ...nuevos])
        }
        open={openModalLista}
        onClose={() => setOpenModalLista(false)}
      />
    </div>
  );
}
